import request from '@/plugins/request';
let Api = {};
const sys = '/user/'
const pre = 'rbac_manager';
// 用户设置群组
Api.userGroups = function (data) {
    return request({
        url: `${sys}${pre}/user_groups`,
        method: 'post',
        data
    });
}
// 用户设置角色
Api.userRoles = function (data) {
    return request({
        url: `${sys}${pre}/user_roles`,
        method: 'post',
        data
    });
}
// 分组设置用户
Api.groupUsers = function (data) {
    return request({
        url: `${sys}${pre}/group_users`,
        method: 'post',
        data
    });
}
// 分组设置角色
Api.groupRoles = function (data) {
    return request({
        url: `${sys}${pre}/group_roles`,
        method: 'post',
        data
    });
}
// 角色设置用户
Api.roleUsers = function (data) {
    return request({
        url: `${sys}${pre}/role_users`,
        method: 'post',
        data
    });
}
// 角色设置分组
Api.roleGroups = function (data) {
    return request({
        url: `${sys}${pre}/role_groups`,
        method: 'post',
        data
    });
}
// 角色设置菜单
Api.roleMenus = function (data) {
    return request({
        url: `${sys}${pre}/role_menus`,
        method: 'post',
        data
    });
}
// 菜单设置角色
Api.menuRoles = function (data) {
    return request({
        url: `${sys}${pre}/menu_roles`,
        method: 'post',
        data
    });
}
// 表格设置角色
Api.tableRoles = function (data) {
    return request({
        url: `${sys}${pre}/table_roles`,
        method: 'post',
        data
    });
}
// 按钮设置角色
Api.buttonRoles = function (data) {
    return request({
        url: `${sys}${pre}/button_roles`,
        method: 'post',
        data
    });
}
// 部门设置用户
Api.deptUsers = function (data) {
    return request({
        url: `${sys}${pre}/dept_users`,
        method: 'post',
        data
    });
}
export default Api



// WEBPACK FOOTER //
// ./src/api/system/rbac.js